import MainLayout from "../layout/mainLayout";

export default function Task() {
    return (
        <MainLayout
            pageTitle='สิ่งที่ต้องทำ'
            disableFrom={true}
        />
    );
}